<template>
  <div
    class="ag-cell-wrapper"
  >
    <div role="presentation" class="ag-cell-value" disabled="">
      <div
        class="custom-boolean"
        tabindex="-1"
        :style="{color: params.customBooleanColor + ' !important'}" 
      > 
        {{ String(!!params.value).toUpperCase() }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
};
</script>

<style scoped>

</style>